import { StubHubRoutesEnum } from "models/enums/apiRoutes/stubHubApiRoutes";
import {
  IBrokerList,
  IBuyerList,
  IEventList,
  IDistinctEventList,
  IVenueList,
  IDateList,
  ICardList,
  IAlertList,
  ICurrencyList,
  IReportList,
  IRecipientList,
  ISkyboxUserList,
  IRoleList,
  ISplitTypeList,
  IBuyerTagList,
  IListerTagList,
  ITicketbashBrokerList,
  ISaleCategoryList,
  ICustomerClassificationList,
  IStateList,
  ISeatIntelligenceList,
  IScrapingStatusList,
  IListerUserList,
  IBrokerUserList,
  INewVenueList,
  IPaymentStatusesList,
  IAgingPeriodsList,
  ISeatMapCreatorUserList,
  ICheckerUserList,
  IFulfillmentStatusesList,
  IBuyerUserList,
  IShipperList,
  ISkyboxVendorList,
  IInventoryCancellationTypesList,
} from "models/interfaces";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import axiosClient from "sharedServices/api/axios.services";

class FilterOptionsService {
  public getBrokerTagsByReportId = async (queryParams: {
    current_report_id: number;
  }) => {
    return axiosClient.get<IApiBaseResponse<IBrokerList>>(
      StubHubRoutesEnum.BROKER_TAGS_BY_REPORT_ID,
      { params: { ...queryParams } }
    );
  };

  public getBuyers = async () => {
    return axiosClient.get<IApiBaseResponse<IBuyerList>>(StubHubRoutesEnum.BUYER_LIST);
  };

  public getShippers = async () => {
    return axiosClient.get<IApiBaseResponse<IShipperList>>(
      StubHubRoutesEnum.SHIPPER_LIST
    );
  };

  public getEvents = async () => {
    return axiosClient.get<IApiBaseResponse<IEventList>>(StubHubRoutesEnum.EVENT_LIST);
  };

  public getDistinctEventList = async () => {
    return axiosClient.get<IApiBaseResponse<IDistinctEventList>>(
      StubHubRoutesEnum.DISTINCT_EVENT_LIST
    );
  };

  public getVenues = async () => {
    return axiosClient.get<IApiBaseResponse<IVenueList>>(StubHubRoutesEnum.VENUE_LIST);
  };

  public getDateRange = async () => {
    return axiosClient.get<IApiBaseResponse<IDateList>>(StubHubRoutesEnum.DATE_RANGE);
  };

  public getCards = async () => {
    return axiosClient.get<IApiBaseResponse<ICardList>>(StubHubRoutesEnum.CARD_LIST);
  };

  public getAlerts = async () => {
    return axiosClient.get<IApiBaseResponse<IAlertList>>(StubHubRoutesEnum.ALERT_LIST);
  };

  public getCurrencies = async () => {
    return axiosClient.get<IApiBaseResponse<ICurrencyList>>(
      StubHubRoutesEnum.CURRENCY_LIST
    );
  };

  //NEW
  public getReports = async (queryParams: { current_report_id: number }) => {
    return axiosClient.get<IApiBaseResponse<IReportList>>(
      StubHubRoutesEnum.REPORT_LIST,
      { params: { ...queryParams } }
    );
  };

  public getRecipients = async () => {
    return axiosClient.get<IApiBaseResponse<IRecipientList>>(
      StubHubRoutesEnum.RECIPIENT_LIST
    );
  };

  public getSkyBoxUsers = async () => {
    return axiosClient.get<IApiBaseResponse<ISkyboxUserList>>(
      StubHubRoutesEnum.SKYBOX_USER_LIST
    );
  };

  public getSkyBoxVendors = async () => {
    return axiosClient.get<IApiBaseResponse<ISkyboxVendorList>>(
      StubHubRoutesEnum.SKYBOX_VENDORS
    );
  };

  public getRoles = async () => {
    return axiosClient.get<IApiBaseResponse<IRoleList>>(StubHubRoutesEnum.ROLE_LIST);
  };

  public getSplitTypes = async () => {
    return axiosClient.get<IApiBaseResponse<ISplitTypeList>>(
      StubHubRoutesEnum.SPLIT_TYPE_LIST
    );
  };

  public getBuyerTypes = async () => {
    return axiosClient.get<IApiBaseResponse<IBuyerTagList>>(
      StubHubRoutesEnum.BUYER_TAG_LIST
    );
  };

  public getListerTypes = async () => {
    return axiosClient.get<IApiBaseResponse<IListerTagList>>(
      StubHubRoutesEnum.LISTER_TAG_LIST
    );
  };

  public getTicketbashBrokerList = async () => {
    return axiosClient.get<IApiBaseResponse<ITicketbashBrokerList>>(
      StubHubRoutesEnum.TICKETBASH_BROKER_LIST
    );
  };

  public getSaleCategories = async () => {
    return axiosClient.get<IApiBaseResponse<ISaleCategoryList>>(
      StubHubRoutesEnum.SALE_CATEGORY_LIST
    );
  };

  public getCustomerClassifications = async () => {
    return axiosClient.get<IApiBaseResponse<ICustomerClassificationList>>(
      StubHubRoutesEnum.CUSTOMER_CLASSIFICATION_LIST
    );
  };

  public getStates = async () => {
    return axiosClient.get<IApiBaseResponse<IStateList>>(StubHubRoutesEnum.STATE_LIST);
  };

  public getInventoryCancellationTypes = async () => {
    return axiosClient.get<IApiBaseResponse<IInventoryCancellationTypesList>>(StubHubRoutesEnum.INVENTORY_CANCELLATION_TYPE_LIST);
  };

  public getSeatIntelligenceDetails = async () => {
    return axiosClient.get<IApiBaseResponse<ISeatIntelligenceList>>(
      StubHubRoutesEnum.SEAT_INTELLIGENCE_DETAILS
    );
  };

  public getScrapingStatusDetails = async () => {
    return axiosClient.get<IApiBaseResponse<IScrapingStatusList>>(
      StubHubRoutesEnum.SCRAPING_STATUS_DETAILS
    );
  };

  public getBrokerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<IBrokerUserList>>(
      StubHubRoutesEnum.BROKER_USER_LIST
    );
  };

  public getBuyerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<IBuyerUserList>>(
      StubHubRoutesEnum.BUYER_USER_LIST
    );
  };

  public getListerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<IListerUserList>>(
      StubHubRoutesEnum.LISTER_USER_LIST
    );
  };

  public getSeatMapCreatorUserList = async () => {
    return axiosClient.get<IApiBaseResponse<ISeatMapCreatorUserList>>(
      StubHubRoutesEnum.SEAT_MAP_CREATOR_USER_LIST
    );
  };

  public getCheckerUserList = async () => {
    return axiosClient.get<IApiBaseResponse<ICheckerUserList>>(
      StubHubRoutesEnum.CHECKER_USER_LIST
    );
  };

  public getVenuesDatePresets = async () => {
    return axiosClient.get<IApiBaseResponse<INewVenueList>>(
      StubHubRoutesEnum.VENUE_DATE_PRESETS
    );
  };

  public getPaymentStatusList = async () => {
    return axiosClient.get<IApiBaseResponse<IPaymentStatusesList>>(
      StubHubRoutesEnum.ZONE_PAYMENT_STATUS_LIST
    );
  };

  public getAgingPeriodList = async () => {
    return axiosClient.get<IApiBaseResponse<IAgingPeriodsList>>(
      StubHubRoutesEnum.AGING_PERIODS_LIST
    );
  };

  public getFulfillmentStatusList = async () => {
    return axiosClient.get<IApiBaseResponse<IFulfillmentStatusesList>>(
      StubHubRoutesEnum.FULFILLMENT_STATUSES_LIST
    );
  };

  public getShowCategories = async () => {
    return axiosClient.get<IApiBaseResponse>(StubHubRoutesEnum.SHOW_CATEGORIES);
  };

  public getVenueScrapingTypes = async () => {
    return axiosClient.get<IApiBaseResponse>(StubHubRoutesEnum.VENUE_SCRAPING_TYPES);
  };
}

export { FilterOptionsService };
